import React from 'react';
import './App.css';
import './styles/main.scss';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard'
import EditUser from './components/EditUser'
import AddUser from './components/AddUser';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Message from './components/Message';
import EditRoles from './components/EditRoles';
import PlotList from './components/PlotList';
import Unauthorized from './components/Unauthorized';
import Plot from './components/Plot';
import AddPlot from './components/AddPlot';
import { AuthProvider } from './context/AuthContext';
import EditPlot from './components/EditPlot';

function App() {
  return (   
    <AuthProvider>
      <Router> 
        <div className="">
          <Routes>
              <Route path="/register" element={<Register />} />
              <Route path="/" element={<Login />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/edit-user/:userId" element={<EditUser />} />
              <Route path="/add-user" element={<AddUser />} />
              <Route path="/messages" element={<Message />} />
              <Route path="/add-role" element={<EditRoles />} />
              <Route path="/plots" element={<PlotList />} />
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="//plots/view/:plotId" element={<Plot />} />
              <Route path="//plots/edit/:plotId" element={<EditPlot />} />
              <Route path="/add-plot" element={<AddPlot />} />
              <Route path="/home" element={<Home />} />
                {/* Add other routes here */}
          </Routes>
        </div>
      </Router> 
    </AuthProvider>
  
  );
}

export default App;
